import styled, { css } from 'styled-components';

import { NAVIGATION_MODAL_ZINDEX } from '@telialt/common-constants/src/modal';
import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

type DrawerContainerProps = {
    $isOpen?: boolean;
    $isVisible?: boolean;
};

export const DrawerContainer = styled.div<DrawerContainerProps>`
    position: fixed;
    top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    bottom: 0;
    background: ${getPurpurColor('functionalWhite')};
    width: 100%;
    min-width: 20rem;
    max-width: 24.375rem;
    box-shadow: inset 0rem 0.75rem 0.5rem -0.75rem rgba(0, 0, 0, 0.1);
    transition: left 0.5s;
    display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};

    ${({ $isOpen }) => css`
        left: ${$isOpen ? '0px' : '-26rem'};
    `};

    ${purpurMedia('lg')`
        display: none;
    `};
`;

type DrawerOverlayProps = {
    $isVisible?: boolean;
};

export const DrawerOverlay = styled.div<DrawerOverlayProps>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${getPurpurColor('overlayDefault')};
    transition: opacity 0.3s ease-in-out;
    z-index: ${NAVIGATION_MODAL_ZINDEX - 3};
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};

    ${purpurMedia('lg')`
        display: none;
    `};
`;
